export default __webpack_public_path__ + "static/form-required-field-do-b265c3f2fd5d28426808a4220cccab98897d0bc292cd669e05543b0ab274a4e6.png";